var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlinedSimIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22396 14.6654C3.85729 14.6654 3.54351 14.5349 3.28262 14.274C3.02174 14.0131 2.89107 13.6991 2.89062 13.332V5.33203L6.89062 1.33203H12.224C12.5906 1.33203 12.9046 1.4627 13.166 1.72403C13.4273 1.98536 13.5577 2.29914 13.5573 2.66536V13.332C13.5573 13.6987 13.4268 14.0127 13.166 14.274C12.9051 14.5354 12.5911 14.6658 12.224 14.6654H4.22396ZM4.22396 13.332H12.224V2.66536H7.45729L4.22396 5.8987V13.332Z",
    fill: "#264C86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedSimIcon);
export default __webpack_public_path__ + "static/media/outlined_sim_icon.0a47bb145492ad591b415156c4c526d6.svg";
export { ForwardRef as ReactComponent };